import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

import ButtonWithLoading, { WithLoadingProps } from '../buttons/with-loading';

type Props = WithLoadingProps & {
  title: string;
  loading?: boolean;
  fullWidth?: boolean;
};

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: theme.spacing(2.5),
    background: theme.palette.primary.main,
    padding: theme.spacing(9.75, 4),
    color: theme.palette.common.white,
    fontSize: theme.spacing(8),
    lineHeight: '18px',
    textTransform: 'none',
    fontWeight: 'normal',
    transition: '.2s ease-in-out',
    '&:hover': {
      background: theme.palette.primary.main,
      filter: 'brightness(90%)',
    },
    '&:disabled': {
      opacity: 0.7,
      cursor: 'not-allowed',
    },
  },
}));

const AuthButton: React.FC<Props> = ({ title, fullWidth, loading, disabled, ...props }) => {
  const classes = useStyles();

  return (
    <ButtonWithLoading
      type="submit"
      fullWidth={fullWidth}
      isLoading={loading}
      className={classes.root}
      disabled={disabled}
      {...props}
    >
      {title}
    </ButtonWithLoading>
  );
};

export default AuthButton;
